export const headers = () => {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  return {
    'Content-Type': 'application/json',
    'X-CSRF-Token': csrfToken || ''
  }
}